// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE GUIDED FLOW'S SLIM WHITE "WELCOME BACK" CARD, as a component (2026-11-03). GuidedShell's returning-borrower
// banner ("Welcome back, Ana. You’re on step 7 of 8.") was an inline div; it is this component now, unchanged, so the
// dashboard's greeting option 'a' (constants/journeySteps DASHBOARD_GREETING) reuses it rather than copying its style.
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';

// The shell's banner box — every GuidedShell banner uses it (moved here from GuidedShell, unchanged) — and the welcome
// card's white face on it.
export const BANNER = Object.freeze({ padding: '12px 14px', borderRadius: 10, fontSize: 14, lineHeight: 1.45, marginTop: 12 });
export const WELCOME_CARD_STYLE = Object.freeze({ ...BANNER, background: '#fff', border: '1px solid #e0e4f5', color: '#000' });

export default function GuidedWelcomeCard({ testId, children, style = undefined }) {
  return <div data-testid={testId} style={style ? { ...WELCOME_CARD_STYLE, ...style } : WELCOME_CARD_STYLE}>{children}</div>;
}
